var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineFlashCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.57 18.08c-.55-.21-.91-.72-.91-1.31v-3.3h-.98c-.56 0-1.05-.32-1.28-.82-.23-.51-.14-1.08.23-1.5l4.26-4.84c.39-.44.99-.59 1.54-.38.55.21.91.72.91 1.31v3.3h.99c.56 0 1.05.32 1.28.82.23.51.14 1.08-.23 1.5l-4.26 4.84c-.28.3-.66.47-1.05.47-.17 0-.33-.03-.5-.09zm-.16-6.11c.41 0 .75.34.75.75v3.78l3.94-4.47h-1.51c-.41 0-.75-.34-.75-.75V7.5L8.9 11.97h1.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22 12c0-5.93 4.83-10.75 10.75-10.75S22.72 6.07 22.72 12 17.9 22.75 11.97 22.75C6.05 22.75 1.22 17.93 1.22 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25S2.72 6.9 2.72 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFlashCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-flash-circle.853a1782cfd2d58ed0c5fb6f6be361d7.svg";
export { ForwardRef as ReactComponent };